var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.showBar)?_c('AppBar'):_vm._e(),(this.$store.state.postsloaded)?_c('v-main',[_c('v-container',[_c('router-view')],1)],1):_vm._e(),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }